export default __webpack_public_path__ + "static/media/lord-hanuman.8be35205.jpg";